






export default {
  name: 'vertical-splitter'
}



// WEBPACK FOOTER //
// ./src/components/vertical-splitter.vue